import Box from "@mui/material/Box";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import MPHome from "./MPHome";
import MPHomeApps from "./BarberMainPageComps/MPHomeApps";
import React, { useState, useEffect, useCallback, useRef } from "react";
import moment from "moment";
import axios from "axios";
import { MyDomain } from "../App";
import { useAppContext } from "../AppContext";
import { useParams } from "react-router-dom";
import * as signalR from "@microsoft/signalr";
import { useTranslation } from "react-i18next";

export default function BarberMainPage() {
  const { t } = useTranslation();

  const {
    OpenDrawer,
    setOpenDrawer,
    setAllApps,
    Loading,
    setLoading,
    setChoosedDate,
    setChoosedApps,
    setAllData,
    setUser,
    User,
    setAppContextLoading,
    AppContextLoading,
    OtherBarbers,
    setOtherBarbers,
    refreshDataCallback,
    setValue,
    value,
    AllowUsersBookApp,
    setAllowUsersBookApp,
    WazeData,
    setWazeData,
  } = useAppContext();

  const { BarberPhoneNumber } = useParams();
  const hubRef = useRef(null);

  // ✅ Use useCallback to prevent infinite loops
  const GetAllApps = useCallback(() => {
    //setLoading(false);

    const data = {
      PhoneNumber: BarberPhoneNumber,
    };

    axios
      .post(`${MyDomain}Barbers2/GetAllBarberData`, data)
      .then((response) => {
        console.log("✅ Data fetched:", response.data);
        setAllowUsersBookApp(response.data.barberData.allowUsersBookApp);

        setAllApps(response.data.barberAppointments);
        setAllData(response.data);
        setWazeData(response.data.barberShopPlace);
        // Combine owner (barberData) with other barbers
        const allBarbersList = [];

        if (response.data.barberData) {
          allBarbersList.push(response.data.barberData);
        }

        if (response.data.allBarbers && response.data.allBarbers.length > 0) {
          allBarbersList.push(...response.data.allBarbers);
        }

        if (allBarbersList.length > 1) {
          setOtherBarbers(allBarbersList);
        }

        const today = moment().format("DD-MM-YYYY");
        const todaysAppointments = response.data.barberAppointments.filter(
          (app) => app.date === today
        );

        setChoosedApps(todaysAppointments);
        setChoosedDate(moment().format("DD-MM-YYYY"));
        setLoading(true);
      })
      .catch((err) => {
        console.error("❌ Error fetching data:", err);
        //setLoading(false);
      });
  }, [BarberPhoneNumber]);

  // ✅ Initial fetch
  useEffect(() => {
    GetAllApps();
  }, [BarberPhoneNumber]);

  // ✅ SignalR setup
  useEffect(() => {
    if (!BarberPhoneNumber) {
      console.warn("⚠️ No BarberPhoneNumber available");
      return;
    }

    console.log("🔄 Setting up SignalR for barber:", BarberPhoneNumber);

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${MyDomain}appointmentHub`)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.elapsedMilliseconds < 60000) {
            return Math.random() * 10000;
          }
          return null;
        },
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    hubRef.current = connection;

    // Handle connection events
    connection.onclose((error) => {
      console.log("🔌 BarberMainPage SignalR connection closed");
      if (error) {
        console.log("Reason:", error.message);
      }
    });

    connection.onreconnecting(() => {
      console.log("🔄 BarberMainPage SignalR reconnecting...");
    });

    connection.onreconnected((connectionId) => {
      console.log("✅ BarberMainPage SignalR reconnected! ID:", connectionId);
      GetAllApps(); // Refresh data after reconnection
    });

    const startConnection = async () => {
      try {
        if (connection.state === signalR.HubConnectionState.Disconnected) {
          await connection.start();
          console.log("✅ BarberMainPage SignalR connected!");
          console.log("🔑 Connection ID:", connection.connectionId);

          // ✅ Listen for AppointmentCreated
          connection.on("AppointmentCreated", (newAppointment) => {
            console.log("📩 AppointmentCreated:", newAppointment);
            GetAllApps();
            setOpenDrawer(false);
          });

          // ✅ Listen for ReceiveBookingUpdate (from UpdateAppWithServices)
          connection.on("ReceiveBookingUpdate", (updatedAppointment) => {
            console.log("📩 ReceiveBookingUpdate:", updatedAppointment);
            GetAllApps();
            setOpenDrawer(false);
          });
        }
      } catch (err) {
        console.error("❌ BarberMainPage SignalR connection error:", err);
        setTimeout(() => {
          if (connection.state === signalR.HubConnectionState.Disconnected) {
            startConnection();
          }
        }, 5000);
      }
    };

    startConnection();

    // ✅ Cleanup
    return () => {
      console.log("🧹 Cleaning up BarberMainPage SignalR...");

      if (connection) {
        connection.off("AppointmentCreated");
        connection.off("ReceiveBookingUpdate");

        const state = connection.state;
        if (
          state === signalR.HubConnectionState.Connected ||
          state === signalR.HubConnectionState.Connecting
        ) {
          connection
            .stop()
            .then(() => console.log("✅ BarberMainPage SignalR disconnected"))
            .catch((err) => {
              if (!err.message?.includes("connection being closed")) {
                console.log("⚠️ Error stopping SignalR:", err.message);
              }
            });
        }
      }
    };
  }, [BarberPhoneNumber, GetAllApps]);

  // ✅ SignalR setup
  // useEffect(() => {
  //   if (!BarberPhoneNumber) {
  //     console.warn("⚠️ No BarberPhoneNumber available");
  //     return;
  //   }

  //   console.log("🔄 Setting up SignalR for barber:", BarberPhoneNumber);

  //   const connection = new signalR.HubConnectionBuilder()
  //     .withUrl(`${MyDomain}appointmentHub`)
  //     .withAutomaticReconnect({
  //       nextRetryDelayInMilliseconds: (retryContext) => {
  //         if (retryContext.elapsedMilliseconds < 60000) {
  //           return Math.random() * 10000;
  //         }
  //         return null;
  //       },
  //     })
  //     .configureLogging(signalR.LogLevel.Information)
  //     .build();

  //   hubRef.current = connection;

  //   connection.onclose((error) => {
  //     console.log("🔌 BarberMainPage SignalR connection closed");
  //     if (error) {
  //       console.log("Reason:", error.message);
  //     }
  //   });

  //   connection.onreconnecting(() => {
  //     console.log("🔄 BarberMainPage SignalR reconnecting...");
  //   });

  //   connection.onreconnected((connectionId) => {
  //     console.log("✅ BarberMainPage SignalR reconnected! ID:", connectionId);
  //     GetAllApps(); // Only refresh after reconnection
  //   });

  //   const startConnection = async () => {
  //     try {
  //       if (connection.state === signalR.HubConnectionState.Disconnected) {
  //         await connection.start();
  //         console.log("✅ BarberMainPage SignalR connected!");
  //         console.log("🔑 Connection ID:", connection.connectionId);

  //         // ✅ Listen for AppointmentCreated - UPDATE STATE DIRECTLY
  //         connection.on("AppointmentCreated", (newAppointment) => {
  //           console.log("📩 AppointmentCreated:", newAppointment);

  //           // Add new appointment to existing state
  //           setAllApps((prevApps) => [...prevApps, newAppointment]);

  //           // If it's today's appointment, add it to choosedApps too
  //           const today = moment().format("DD-MM-YYYY");
  //           if (newAppointment.date === today) {
  //             setChoosedApps((prevApps) => [...prevApps, newAppointment]);
  //           }

  //           setOpenDrawer(false);
  //         });

  //         // ✅ Listen for ReceiveBookingUpdate - UPDATE STATE DIRECTLY
  //         connection.on("ReceiveBookingUpdate", (updatedAppointment) => {
  //           console.log("📩 ReceiveBookingUpdate:", updatedAppointment);

  //           // Update the appointment in existing state
  //           setAllApps((prevApps) =>
  //             prevApps.map((app) =>
  //               app.id === updatedAppointment.id ? updatedAppointment : app
  //             )
  //           );

  //           // Update in choosedApps if it exists there
  //           const today = moment().format("DD-MM-YYYY");
  //           if (updatedAppointment.date === today) {
  //             setChoosedApps((prevApps) =>
  //               prevApps.map((app) =>
  //                 app.id === updatedAppointment.id ? updatedAppointment : app
  //               )
  //             );
  //           } else {
  //             // If date changed and it's not today anymore, remove it
  //             setChoosedApps((prevApps) =>
  //               prevApps.filter((app) => app.id !== updatedAppointment.id)
  //             );
  //           }

  //           setOpenDrawer(false);
  //         });
  //       }
  //     } catch (err) {
  //       console.error("❌ BarberMainPage SignalR connection error:", err);
  //       setTimeout(() => {
  //         if (connection.state === signalR.HubConnectionState.Disconnected) {
  //           startConnection();
  //         }
  //       }, 5000);
  //     }
  //   };

  //   startConnection();

  //   // ✅ Cleanup
  //   return () => {
  //     console.log("🧹 Cleaning up BarberMainPage SignalR...");

  //     if (connection) {
  //       connection.off("AppointmentCreated");
  //       connection.off("ReceiveBookingUpdate");

  //       const state = connection.state;
  //       if (
  //         state === signalR.HubConnectionState.Connected ||
  //         state === signalR.HubConnectionState.Connecting
  //       ) {
  //         connection
  //           .stop()
  //           .then(() => console.log("✅ BarberMainPage SignalR disconnected"))
  //           .catch((err) => {
  //             if (!err.message?.includes("connection being closed")) {
  //               console.log("⚠️ Error stopping SignalR:", err.message);
  //             }
  //           });
  //       }
  //     }
  //   };
  // }, [BarberPhoneNumber]); // ✅ Removed GetAllApps from dependencies
  const navItems = [
    { label: `${t("TheMainPage")}`, icon: <HomeOutlinedIcon /> },
    { label: `${t("myappointments")}`, icon: <CalendarMonthOutlinedIcon /> },
  ];

  const loadUser = async () => {
    try {
      const value = await localStorage.getItem("User");
      if (value !== null) {
        setUser(JSON.parse(value));
        console.log("✅ User loaded!", JSON.parse(value));
      } else {
        console.log("⚠️ No user found in localStorage");
      }
    } catch (e) {
      console.error("❌ Failed to load user", e);
    } finally {
      setAppContextLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  // if (AppContextLoading) {
  //   return (
  //     <div>
  //       <a>loading</a>
  //     </div>
  //   );
  // }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      {Loading ? (
        <>
          <div style={{ flex: 1, paddingBottom: "80px" }}>
            <div
              style={{
                display: value === 0 ? "block" : "none",
              }}
            >
              <>
                <MPHome />
              </>
            </div>
            <div
              style={{
                display: value === 1 ? "block" : "none",
              }}
            >
              <MPHomeApps />
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              border: "4px solid #667eea",
              borderTopColor: "transparent",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <div
            style={{
              fontSize: "16px",
              color: "#6b7280",
              fontWeight: "500",
            }}
          >
            Loading...
          </div>
        </div>
      )}

      {/* Custom Bottom Navigation */}
      <Box
        sx={{
          width: "100%",
          position: "fixed",
          bottom: 0,
          left: 0,
          zIndex: 1100,
          backgroundColor: "#fff",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          borderTop: "1px solid #e5e7eb",
          transform: OpenDrawer ? "translateY(100%)" : "translateY(0)",
          transition: "transform 0.3s ease",
          opacity: OpenDrawer ? 0 : 1,
          pointerEvents: OpenDrawer ? "none" : "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            height: "70px",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          {navItems.map((item, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setValue(index);
              }}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
                position: "relative",
                transition: "all 0.3s ease",
                padding: "8px",
                WebkitTapHighlightColor: "transparent",
                outline: "none",
                userSelect: "none",
              }}
            >
              {value === index && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "40px",
                    height: "3px",
                    backgroundColor: "#667eea",
                    borderRadius: "0 0 3px 3px",
                  }}
                />
              )}

              <div
                style={{
                  color: value === index ? "#667eea" : "#9ca3af",
                  transition: "color 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {React.cloneElement(item.icon, {
                  sx: {
                    fontSize: "26px",
                  },
                })}
              </div>

              <span
                style={{
                  fontSize: "12px",
                  fontWeight: value === index ? "600" : "500",
                  color: value === index ? "#667eea" : "#9ca3af",
                  transition: "all 0.3s ease",
                }}
              >
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </Box>

      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
}
